import Images from "../../../../config/Images";
import "./ProjectNavBarBack.css";
import {useDispatch} from "react-redux";



type ProjectNavBarBackProps = {
  onClick: () => void;
};


const ProjectNavBarBack: React.FC<ProjectNavBarBackProps> = ({ onClick }) => {
  

  return (
    <div className={'project-nav-back'} onClick={onClick}>
      <div className={'project-nav-back-click'}>
        <i className="fa-solid fa-chevron-left"/>
        <p className={'project-nav-back-text'} >
          &nbsp; Back
        </p>
      </div>
     
    </div>
  )
}

export default ProjectNavBarBack;
